import { DirectoryScreenConfigSchema, type DirectoryScreenConfig } from '@school-journey/shared-types'

import type { ScreenFeatureEntry } from './entry'

/**
 * Screen `directory`.
 *
 * Not absentIsEmpty: the fleet-default SCREEN_CONFIGS row carries `directory`
 * (read-only production query, `SystemConfiguration`, 2026-10-02), so a
 * not-found answer is a real fault.
 *
 * No fallback: nothing in `apps/mobile/src` or `apps/backend/src` resolves an
 * absent `defaultSort` or `filters.*`, so there is no resolver value to mirror.
 */
export const directory: ScreenFeatureEntry<'screen', 'directory', DirectoryScreenConfig> = {
  resource: 'screen',
  wireName: 'directory',
  schema: DirectoryScreenConfigSchema,
  writeMode: 'replace',
  fallback: {}
}
